import React, { createContext, lazy, Suspense, useContext } from 'react';

import './App.scss';

import useContainerContext, { WorkflowsContextType } from './hooks/useContainerContext';


export const WorkflowsContext = createContext({} as WorkflowsContextType);
export const useWorkflowsContext = (): WorkflowsContextType => useContext(WorkflowsContext);

const WorkflowsApp = lazy(() => import('./components/basic/WorkflowsApp'));

const App = () => {
    const containerContext = useContainerContext();
    return (
        <Suspense fallback={<div className='ar-page-loader' />}>
            <WorkflowsContext.Provider value={containerContext}>
                <WorkflowsApp />
            </WorkflowsContext.Provider>
        </Suspense>
    );
};

export default App;
